import React from "react";
import { PaperBG } from "../kits";

export default function Impressum() {
  return (
    <PaperBG>
    <div className="max-w-3xl mx-auto px-6 py-20 font-mono text-xs text-gray-900 space-y-6">
      <h1 className="text-xl font-semibold mb-6 bg-gray-900 px-2 text-orange-50">Impressum</h1>

      <section className="text-xs">
        <h2 className="text-md font-semibold mb-2">Angaben gemäß § 5 TMG</h2>
        <p>
          Denis Bitter<br />
          Ferdinandstraße 15<br />
          20095 Hamburg<br />
          Deutschland
        </p>
      </section>

      <section>
        <h2 className="text-md font-semibold mb-2">Kontakt</h2>
        <p>
          E-Mail: <a href="mailto:saghallo@denisbitter.de" className="underline">saghallo@denisbitter.de</a><br />
      
        </p>
      </section>

      <section>
        <h2 className="text-md font-semibold mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
        <p>
            Denis Bitter<br />
            Ferdinandstraße 15<br />
            20095 Hamburg<br />
            Deutschland
        </p>
      </section>

      <section>
        <h2 className="text-md font-semibold mb-2">Haftungsausschluss</h2>
        <p>
          Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für externe Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
        </p>
      </section>

      <section>
        <h2 className="text-md font-semibold mb-2">Urheberrecht</h2>
        <p>
          Alle Inhalte dieser Website (Texte, Grafiken, Bilder, Videos) unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung oder Verbreitung ist ohne ausdrückliche Zustimmung nicht gestattet.
        </p>
      </section>

      <footer className="text-xs text-orange-50 bg-gray-900 border rounded-sm mt-10 px-3">
        Stand: Mai 2025
      </footer>
    </div>
    </PaperBG>
  );
}
